import { render, staticRenderFns } from "./pro_05_plating.vue?vue&type=template&id=851a3f74&lang=pug&"
import script from "./pro_05_plating.vue?vue&type=script&lang=js&"
export * from "./pro_05_plating.vue?vue&type=script&lang=js&"
import style0 from "./pro_05_plating.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports